import { ImageOutputAdaptor } from '../imageConfigService.types';

export type BaseImage = {
    src: string;
    seoSrc: string;
    alt: string;
};

const BaseImageOutput: ImageOutputAdaptor<BaseImage> = ({ sources: { seo, url }, alt }) => ({
    src: url,
    seoSrc: seo || url,
    alt,
});

export default BaseImageOutput;
